export const OT_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST— OCCUPATIONAL THERAPIST",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Knowledge of Assessment Process:",
                items: [
                    "a. Health history and physical exam",
                    "b. Development of Problem List",
                    "c. Development and revision of care plan",
                    "d. Assesses response to treatment",
                    "e. Establishes and revises goals",
                    "f. DC planning",
                    "g. Conducts complete initial evaluation",
                    "h. Other"
                ]
            },
            {
                category: "2. Documentation Skills: (accurate, timely, complete, legible)",
                items: [
                    "a. 485, 486, 487",
                    "b. Progress notes, flow sheets",
                    "c. Summary reports",
                    "d. Incident reporting",
                    "e. Other"
                ]
            },
            {
                category: "3. Adheres to POC",
                items: [
                    "a. Reviews POC prior to care",
                    "b. Performs services as ordered",
                    "c. Documents according to POC",
                    "d. Communicates/coordinates as appropriate",
                    "e. Other"
                ]
            }
        ]
    },

    // Page 2: Administrative Continued
    {
        id: 2,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate: (continued)",
        competencies: [
            {
                category: "4. Knowledge of Medicare/State Guidelines:",
                items: [
                    "a. Criteria for participation",
                    "b. Skilled reimbursable visit",
                    "c. Other"
                ]
            },
            {
                category: "5. Reports and documents key information to Physician, DC planner, Clinician, Pharmacist, Supervisor"
            },
            {
                category: "6. Submits written summary reports as indicated"
            },
            {
                category: "7. Attends/participates in case conferences as required"
            },
            {
                category: "8. Supervision of ancillary Personnel:",
                items: [
                    "a. OTA",
                    "b. HHA"
                ]
            },
            {
                category: "9. Supply/HME requisition and management"
            },
            {
                category: "10. Infection Control Practices:",
                items: [
                    "a. Hand washing",
                    "b. Personal protective equipment",
                    "c. Exposure control plan",
                    "d. Equipment care, as appropriate",
                    "e. Other"
                ]
            },
            {
                category: "11. Patient home safety"
            },
            {
                category: "12. Other"
            },
            {
                category: "B. Patient Education:",
                items: [
                    "1. Determines learning needs",
                    "2. Sets objectives",
                    "3. Develops/implement teaching plan",
                    "4. Evaluates effectiveness of teaching",
                    "5. Revises teaching plan",
                    "6. Documents patient response"
                ]
            }
        ]
    },

    // Page 3: Clinical Skills & Assessment
    {
        id: 3,
        type: 'section',
        title: "C. Clinical Skills—General & D. Assessment and Evaluation:",
        competencies: [
            {
                category: "C. Clinical Skills—General:",
                items: [
                    "1. Vital Signs",
                    "2. Other"
                ]
            },
            {
                category: "D. Assessment and Evaluation:",
                items: [
                    "1. Mental Status/Cognition (judgment, memory judgment, orientation, sequencing, following directions, problem solving)",
                    "2. Upper Extremity (ROM, strength, coordination)",
                    "3. Balance/trunk control",
                    "4. Ambulation/endurance",
                    "5. Transfers",
                    "6. Pain/edema, synergy",
                    "7. Visual/sensory/perceptual performance",
                    {
                        text: "8. Functional Findings",
                        subItems: [
                            "a. Eating/feeding",
                            "b. Dressing",
                            "c. Hygiene",
                            "d. Toileting",
                            "e. Cooking/laundry/cleaning/home skills",
                            "f. Writing/phone use",
                            "g. Leisure interest",
                            "h. Time use and structuring",
                            "i. Medication management",
                            "j. Other"
                        ]
                    },
                    "9. Architectural barriers/equipment needs/safety",
                    "10. Other tests or measurements"
                ]
            }
        ]
    },

    // Page 4: Skilled Treatments/Interventions
    {
        id: 4,
        type: 'section',
        title: "E. Skilled Treatments/Interventions:",
        competencies: [
            {
                category: "E. Skilled Treatments/Interventions:",
                items: [
                    "1. Teaches ADL/IADL Program",
                    "2. Work simplification and energy conservation",
                    "3. Teaches muscle reeducation program",
                    "4. Perceptual motor training",
                    "5. Fine motor training/dexterity training/gross motor training",
                    "6. Neuro-developmental training",
                    "7. Sensory enhancement (tactile, ocular, gustatory, Olfactory, proprioceptive, auditory, vestublar, kinesthesia)",
                    "8. Arranges orthotics/splinting",
                    "9. Arranges adaptive equipment",
                    "10. Teaches caregiver exercises/activities",
                    "11. Safety evaluation/environment adaption recommendations",
                    "12. Work capacity evaluation",
                    "13. Other"
                ]
            }
        ]
    },

    // Page 5: Comments & Signatures
    {
        id: 5,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "employeeDate", inputType: "date" },
            { label: "Supervisor Signature", name: "supervisorSignature" },
            { label: "Date", name: "supervisorDate", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor1Signature" },
            { label: "Date", name: "preceptor1Date", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor2Signature" },
            { label: "Date", name: "preceptor2Date", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor3Signature" },
            { label: "Date", name: "preceptor3Date", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 6,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const OT_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Occupational Therapist",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The occupational therapist contracted through the Organization is responsible for the implementation of standards of care for occupational therapy services and for adherence to all conditions outlined in the Service Agreement."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Evaluates patient's functional status (muscle function, endurance, visual coordination, written and verbal communication skills, self care ability, work capacity, etc.). Evaluates home environment for hazards or barriers to more independent living. Identifies equipment needs. Participates in the development of the total plan of care.",
            "For patients who plan to return to work, the occupational therapist may perform work capacity evaluation and may refer to specialized vocational training in accordance with Organization policy.",
            "Develops treatment program and establishes goals for improved function. Communicates plan of care to referring physician and other Organization professionals.",
            "May teach new skills or retrain patient in once familiar daily activities that have been lost due to illness or injury, in accordance with Organization policy.",
            "May fabricate splints and instruct patient in the use of various types of adaptive equipment to improve function.",
            "May train patient in the use of prosthetic and/or orthotic devices.",
            "Maintains appropriate clinical records, clinical notes, and reports to the physician any changes in the patient's condition. Submits these records in accordance with Organization policy.",
            "Maintains contact/communication with other personnel involved in the patient's care to promote coordinated, efficient care.",
            "Attends and contributes to inservices, case conferences, and other meetings as required by Organization policy to ensure coordinated and comprehensive plans of care for the patients of the Organization.",
            "Identifies patient and family/caregiver needs for other home health services and refers as appropriate.",
            "Instructs patient's family/caregiver and other Organization health care personnel in patient's treatment regime when indicated and appropriate.",
            "Supervises Certified Occupational Therapy Assistants according to organization policy and state regulations.",
            "When therapy is the only skilled service, instructs, supervises and evaluates home health aide care every two (2) weeks.",
            "Participates in discharge planning for patient."
        ],
        generalStatement: "The above statements are only meant to be a representative summary of the major duties and responsibilities performed by incumbents of this job. The incumbents may be requested to perform job related tasks other than those stated in this description."
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Graduate of an occupational therapy curriculum accredited jointly by the Committee on Allied Health Education and Accreditation of the American Medical Association and the American Occupational Therapy Association.",
            "Registered with the National Registration Examination of the American Occupational Therapy Association.",
            "Two years of clinical experience as an occupational therapist.",
            "Demonstrates good verbal and written communication, and organization skills.",
            "Possesses and maintains current CPR Certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
